import {MCImplementation} from '@adsk/bim360-mc-implementation';

let DocsSDK;

export default class {
  constructor(config, tokenConfig) {
    DocsSDK = new MCImplementation({
      ...config,
      withCredentials: false,
      token: tokenConfig.token,
      expireTime: tokenConfig.expirationTime
    });
  }

  static refreshCookie() {
    return DocsSDK.refreshCookie();
  }

  getProjectById(projectId) {
    return DocsSDK.getProjectById(projectId);
  }

  getDocumentsByURNs(projectId, urns) {
    return DocsSDK.getDocumentsByURNs(projectId, urns);
  }

  getFoldersListByProjectId(projectId) {
    return DocsSDK.getFoldersListByProjectId(projectId);
  }

  getFolderContents(projectId, urn, options) {
    return DocsSDK.getFolderContents(projectId, urn, options);
  }

  getAllUsersInProject(projectId) {
    return DocsSDK.getAllUsersInProject(projectId);
  }

  getCompaniesInProject(projectId) {
    return DocsSDK.getCompaniesInProject(projectId);
  }

  getRolesInProject(projectId) {
    return DocsSDK.getRolesInProject(projectId);
  }

  getDocumentVersions(projectId, folderUrn, docUrn) {
    return DocsSDK.getDocumentVersions(projectId, folderUrn, docUrn);
  }
}
